/* globals Promise:true, tableau */
import 'babel-polyfill';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MobileDetect from 'mobile-detect';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory, hashHistory } from 'react-router';
import { Provider } from 'react-redux';
import configureStore from './configureStore.jsx';
import App from './components/App.jsx';
import $ from 'jquery';
import {teal500} from 'material-ui/styles/colors';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';



injectTapEventPlugin();

const store = configureStore();

const muiTheme = getMuiTheme({
  palette: {
    textColor: '#5B5C5D',
  },
  toolBar: {
    backgroundColor: teal500,
    height: 50,
  },
});

// import {
//     addLocaleData,
//     injectIntl,
//     IntlProvider,
//     FormattedRelative,
// } from 'react-intl';
// import en from 'react-intl/locale-data/en';
// import nl from 'react-intl/locale-data/nl';
// import localeData from './build/locales/data.json';
// addLocaleData([...en, ...nl]);

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider muiTheme={muiTheme}>
      <Router history={hashHistory}>
        <Route path='/' component={App} />
      </Router>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./index.jsx